import { MINMAX_STORE_LIST } from "../types";
import { MINMAX_GET } from "../types";
import { MINMAX_ADD } from "../types";
import { MINMAX_DELETE } from "../types";

export const minMaxGetStoreListAction = (onSuccess, onError) => {
  return {
    type: MINMAX_STORE_LIST,
    onSuccess,
    onError,
  };
};

export const minMaxGetAction = (data,onSuccess, onError) => {
  return {
    type: MINMAX_GET,
    data,
    onSuccess,
    onError,
  };
};

export const minMaxAddAction = (data, onSuccess, onError) => {
  return {
    type: MINMAX_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const minMaxDeleteAction = (data, onSuccess, onError) => {
  return {
    type: MINMAX_DELETE,
    data,
    onSuccess,
    onError,
  };
};


